import { Field, ErrorMessage } from 'formik';
import FormUpload from '../../../../../components/formUpload/FormUpload';
import { DOCUMENT_CONSTANTS } from '../../../../../utils/constants/MilestoneConstants';
import { mergeUploadedFiles, applyFocDocFieldError } from './UploadDocuments.helpers';

const FocDocUploader = ({ form, selectedFiles, setSelectedFiles }) => (
    <FormUpload
        selectedFiles={selectedFiles}
        setSelectedFiles={setSelectedFiles}
        title='Attachments'
        multiple={true}
        maxDocuments={DOCUMENT_CONSTANTS.MAX_DOCUMENTS_PER_DEAL_FINANCING}
        showErrorSummary={false}
        onChangeHandle={(files) => {
            const mergedFiles = mergeUploadedFiles(form.values.foc_doc || [], files);
            form.setFieldValue('foc_doc', mergedFiles);
            applyFocDocFieldError(form, mergedFiles);
        }}
        handleFormikRemove={(updatedFiles) => {
            form.setFieldValue('foc_doc', updatedFiles);
            applyFocDocFieldError(form, updatedFiles);
        }}
    />
);

const UploadDocuments = (props) => {
    return (
        <div className='accordion-item'>
            <h2 className='accordion-header' id='flush-headingFive'>
                <button
                    className='accordion-button collapsed accordion-title px-3'
                    type='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#flush-collapseFive'
                    aria-expanded='false'
                    aria-controls='flush-collapseFive'>
                    Upload Documents
                </button>
            </h2>
            <div
                id='flush-collapseFive'
                className='accordion-collapse collapse show'
                aria-labelledby='flush-headingFive'
                data-bs-parent='#accordionFlushExample'>
                <div className='accordion-body p-0 px-1 pb-4'>
                    <div className='col-10 px-3 text-start'>
                        <div className='col-6'>
                            <Field name='foc_doc' className='form-control font-b2'>
                                {({ field, form, meta }) => (
                                    <Field name='foc_doc' className='form-control font-b2'>
                                        {({ form: innerForm }) => (
                                            <FocDocUploader
                                                form={innerForm}
                                                selectedFiles={props.mailSelectedFiles}
                                                setSelectedFiles={props.setEmailSelectedFiles}
                                            />
                                        )}
                                    </Field>
                                )}
                            </Field>
                            <ErrorMessage
                                name='foc_doc'
                                component='div'
                                className='error-message font-b4 text-error-700'
                            />
                        </div>
                        <div className='col-6 mt-3 text-start'>
                            <label className='form-label text-neutral-800 font-b3 mb-1 w-100'>
                                Description (Optional)
                                <span className='float-end font-b3'>
                                    {`${props.formikProps.values.doc_description?.length || 0}/255`}
                                </span>
                            </label>
                            <Field
                                className='form-control form-control-sm'
                                as='textarea'
                                id='doc_description'
                                name='doc_description'
                                maxLength={255}
                                rows='3'></Field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UploadDocuments;
